export const VERSION_APP = '1.0.1';
export const HOME_DIR = '/';
export const ENV = {
    PROD: {
        API_BASE_URL1: 'https://script.google.com/macros/s/AKfycbx8zjJwF-MtUwHBkwVQ_HKhTZP4nuWjH0qulD6DIIbwmvkBZ2_SH2d8qvupkch5K60r/exec',
        API_BASE_URL2: 'https://script.google.com/macros/s/AKfycbxD3DMsfKbLIcNv_gkkMDP2Cou1fiWZ6DCMo_ubWk4BgEv8dMkEbFP1JO60Vz5vRAvZ/exec',
        API_BASE_URL3: 'https://script.google.com/macros/s/AKfycbxzPAR7wD1BjafrIgzQuUkCM0Z8s9EyNTbLTAiECP4YjktE8LHktcPXxNcmBa85Vpaz/exec',
        API_BASE_URL4: 'https://script.google.com/macros/s/AKfycbzdgT8PXyz8WgmRdBpAq-8REm0Y6Qs1HARFj-JfWPa-yHOGG_IjM4t9muCR-_TEJ2PLeg/exec',
        API_BASE_URL5: 'https://script.google.com/macros/s/AKfycbz6iFwuxZOKMSk6H3RNOuntmP3KN8w5Ag0Di7-hwALbw_ZX8oHYk3KORQxcoHLa20a4/exec',
        API_BASE_URL6: 'https://script.google.com/macros/s/AKfycbyhNHbyZWV909ecO8bQB6n_Md8TzfLAPjzntyRxTQ4M3wg0n-H2z7hauGtG6Hk1ypgZpg/exec',
        API_BASE_URL7: 'https://script.google.com/macros/s/AKfycbwkHuhMIohZZnw8wY63SucrzXqii0OhnJqbUGOFFWK2wXIDSNhDRxKEXkWjWgaX4_m1/exec',
        API_BASE_URL8: 'https://script.google.com/macros/s/AKfycbxhXKwfxh5om1N9cEqYFev2aaTcPD0jDngOOne_PaaxQ1h-5I0Bqn_qf3XAZKsTvLQy/exec',
        API_BASE_URL9: 'https://script.google.com/macros/s/AKfycbzMoGNVVQNORv7jxGLGJ6X5KLShYxnBlNe44iNYMWn1LbOEvMV8XbLkOqsOpCMSPuID/exec',
        API_BASE_URL10: 'https://script.google.com/macros/s/AKfycbz1xGojK6xqpdWQAMaiX8cHbHU8JwD4kNxPcHyV8r-lBe2RSnEj3IAk8M9mykrNhFEwhg/exec',
        LIFF_ID1: '2005555066-ONXgjeLZ',
        LIFF_ID2: '2005555066-k32MOGW6',
        LIFF_ID3: '2005555066-RWv8QGL0',
        LIFF_ID4: '2005555066-dERPb5gQ',
        LIFF_ID5: '2005555066-ljxoA6rd',
        LIFF_ID6: '2005555066-qxoGRYb9',
        LIFF_ID7: '2005555066-KkwoV41E',
        LIFF_ID8: '2005555066-mDrZ9vdz',
        LIFF_ID9: '2005555066-eN3oJnqb',
        LIFF_ID10: '2005555066-Z8D1vXGz',
        FLEX_IMAGE1: 'https://i.postimg.cc/3rBt7Dnv/flex1.png',
        FLEX_IMAGE2: 'https://i.postimg.cc/T1RQgRY1/flex2.png',
        FLEX_IMAGE3: 'https://i.postimg.cc/mk8jS0tw/flex3.png',
        FLEX_IMAGE4: 'https://i.postimg.cc/qMvj7M5Z/flex4.png',
        FLEX_IMAGE5: 'https://i.postimg.cc/kgVsxY9Q/flex5.png',
        FLEX_IMAGE6: 'https://i.postimg.cc/8zqHwdPq/flex6.png',
        FLEX_IMAGE7: 'https://i.postimg.cc/TPgcsyKh/flex7.png',
        FLEX_IMAGE8: 'https://i.postimg.cc/76NnxpMk/flex8.png',
        FLEX_IMAGE9: 'https://i.postimg.cc/yxYXWvvS/flex9.png',
        FLEX_IMAGE10: 'https://i.postimg.cc/PxHMntDy/flex10.png',
      
    }
}

export const CURRENT_ENV = ENV.PROD;
 